import { render, staticRenderFns } from "./ModalRuleEdit.vue?vue&type=template&id=ede84910&scoped=true"
import script from "./ModalRuleEdit.vue?vue&type=script&lang=js"
export * from "./ModalRuleEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalRuleEdit.vue?vue&type=style&index=0&id=ede84910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede84910",
  null
  
)

export default component.exports